import { useState } from 'react';

import useToast from '@/hooks/useToast';
import { UserCoordinate } from '@/types/hospital';
import {
  AgreementByLocationCategory,
  QnaWriteBottomSheetType,
} from '@/types/qna';

interface requestGeolocationProps {
  onSuccess?: (coordinate: UserCoordinate) => void;
  onError?: () => void;
}
export interface UseQnaWriteBottomSheetGroup {
  onOpenGeolocationTerms: () => void;
  requestGeolocation: ({ onSuccess, onError }: requestGeolocationProps) => void;
  isGeolocationLoading: boolean;
  agreementData?: AgreementByLocationCategory;
  isApprovedByLocationCategory?: boolean;
  setApproveAgreement: () => void;
  activeBottomSheetType?: QnaWriteBottomSheetType;
  onChangeBottomSheetType: (type?: QnaWriteBottomSheetType) => void;
  isCheckedAgreement: boolean;
  onChangeAgreement: () => void;
  isAiAgreementNeeded: boolean;
}
const useQnaWriteBottomSheetGroup = (): UseQnaWriteBottomSheetGroup => {
  const [activeBottomSheetType, setActiveBottomSheetType] =
    useState<QnaWriteBottomSheetType>();
  const [isGeolocationLoading, setIsGeolocationLoading] =
    useState<boolean>(false);
  const [isCheckedAgreement, setIsCheckedAgreement] = useState<boolean>(false);

  const { showToast } = useToast();

  const setApproveAgreement = async () => {
    // if (!agreementData) return;
    //
    // await setApproveAgreementMutate({
    //   request: {
    //     approvedAgreementIds: [Number(agreementData.id)],
    //     disapprovedAgreementIds: [],
    //   },
    // });
  };

  const onChangeBottomSheetType = (type?: QnaWriteBottomSheetType) => {
    if (!type) {
      return setActiveBottomSheetType(undefined);
    }
    setActiveBottomSheetType(type);
  };

  const onChangeAgreement = () => {
    setIsCheckedAgreement((prev) => !prev);
  };

  const onOpenGeolocationTerms = () => {
    // if (!agreementData) return;
    // if (isWebView()) {
    //   return sendPostMessageToNative(
    //     NATIVE_POST_MESSAGE_TYPE.OPEN_EXTERNAL_BROWSER,
    //     {
    //       url: agreementData.url as string,
    //     },
    //   );
    // }
    // window.open(agreementData.url as string, '_blank');
  };

  const requestGeolocation = ({
    onSuccess,
    onError,
  }: requestGeolocationProps) => {
    setIsGeolocationLoading(true);
    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        onChangeBottomSheetType();
        onSuccess?.({
          latitude: coords.latitude,
          longitude: coords.longitude,
        });
      },
      () => {
        if (onError) {
          return onError();
        }
        showToast({
          message: '위치 사용을 허용해야 내 위치 설정이 가능해요',
        });
        setIsGeolocationLoading(false);
        onChangeBottomSheetType();
      },
      { enableHighAccuracy: true, timeout: 10000 },
    );
  };

  return {
    onOpenGeolocationTerms,
    requestGeolocation,
    isGeolocationLoading,
    isApprovedByLocationCategory: true,
    setApproveAgreement,
    activeBottomSheetType,
    onChangeBottomSheetType,
    isCheckedAgreement,
    onChangeAgreement,
    isAiAgreementNeeded: true,
  };
};

export default useQnaWriteBottomSheetGroup;
